'use client';

import type { ExternalToast } from 'sonner';

import { recordShown } from '@/components/install-prompts/schedule';
import { trackClientEvent } from '@/lib/analytics/posthog-client';

export type FirstReviewDesktopToastSource = 'pr_v2';

type FirstReviewDesktopToastParams = {
  installationId?: number | null;
  source: FirstReviewDesktopToastSource;
  onGetApp: () => void;
};

export type FirstReviewDesktopToastData = ExternalToast & {
  message: string;
};

const CAMPAIGN_VERSION = 1;

export function createFirstReviewDesktopToast({
  installationId,
  source,
  onGetApp,
}: FirstReviewDesktopToastParams): FirstReviewDesktopToastData {
  const trackedInstallationId = installationId?.toString();
  let clicked = false;

  // Counts toward the install prompts' one-a-week limit, so no second prompt follows it.
  recordShown();
  trackClientEvent('first_review_desktop_toast_shown', trackedInstallationId, {
    campaign_version: CAMPAIGN_VERSION,
    source,
  });

  return {
    message: 'First review complete',
    description: 'Get the cubic desktop app to improve performance on large PRs',
    duration: 10_000,
    icon: null,
    action: {
      label: 'Get app',
      onClick: () => {
        clicked = true;
        trackClientEvent('first_review_desktop_toast_clicked', trackedInstallationId, {
          campaign_version: CAMPAIGN_VERSION,
          source,
        });
        onGetApp();
      },
    },
    onDismiss: () => {
      if (clicked) {
        return;
      }

      trackClientEvent('first_review_desktop_toast_dismissed', trackedInstallationId, {
        campaign_version: CAMPAIGN_VERSION,
        source,
      });
    },
  };
}
